import React, { useState, useEffect } from 'react';
import { Pagination, Card } from 'antd';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import apiClient from '../../Api/apiClient'; // Adjust the import path as needed
import { PHOTO_BASE_URL_Admin } from '../../Api/config';
import { FaEye, FaHeart } from 'react-icons/fa';
import TenderDescriptionDate from '../../Components/Dashboard/TenderDetails/TenderDescriptionDate';
import TenderDescriptionID from '../../Components/Dashboard/TenderDetails/TenderDescriptionID';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { BsFileEarmarkBreakFill } from 'react-icons/bs';
import tenderNotFoundImage from '../../Assets/images/tenderNotFoundImage.png';

dayjs.extend(customParseFormat);

const { Meta } = Card;

const MyPublishTender = () => {
  const navigate = useNavigate();
  const [tenderData, setTenderData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  // Filter states
  const [keyword, setKeyword] = useState('');
  const [tenderType, setTenderType] = useState('');
  const [sourceType, setSourceType] = useState('');
  const [tenderSection, setTenderSection] = useState('');
  const [tenderStatus, setTenderStatus] = useState('');
  const [district, setDistrict] = useState('');
  const [upazila, setUpazila] = useState('');
  const [publishFromDate, setPublishFromDate] = useState(null);
  const [publishToDate, setPublishToDate] = useState(null);
  const [submissionFromDate, setSubmissionFromDate] = useState(null);
  const [submissionToDate, setSubmissionToDate] = useState(null);

  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(false);

  const userType = localStorage.getItem('user_type');

  // Fetch data from backend
  // useEffect(() => {
  //   const fetchTenders = async () => {
  //     const queryParams = new URLSearchParams({
  //       key: keyword,
  //       // type: tenderType,
  //       // source_type: sourceType,
  //       // tender_section: tenderSection,
  //       // // status: tenderStatus,
  //       // district_name: district,
  //       // upazila_name: upazila,
  //       // publish_from_date: publishFromDate
  //       //   ? dayjs(publishFromDate).format('YYYY-MM-DD')
  //       //   : '',
  //       // publish_to_date: publishToDate
  //       //   ? dayjs(publishToDate).format('YYYY-MM-DD')
  //       //   : '',
  //       // submission_from_date: submissionFromDate
  //       //   ? dayjs(submissionFromDate).format('YYYY-MM-DD')
  //       //   : '',
  //       // submission_to_date: submissionToDate
  //       //   ? dayjs(submissionToDate).format('YYYY-MM-DD')
  //       //   : '',
  //       skip: currentPage,
  //       limit: pageSize,
  //     });

  //     try {
  //       // let url = `/user/?tender-user/published-tender${queryParams.toString()}`
  //       let url = `/user/tender-user/published-tender?key=${keyword}`
  //       if(userType === 'affiliate') url = `/affiliator/tender-request/published-tender?key=${keyword}`
  //       const response = await apiClient.get(
  //         url,
  //       );
  //       const tenders = response.data.data;
  //       console.log("publish tender:", tenders);

  //       // Apply frontend filtering based on the status (if applicable)
  //       const filteredTenders = tenderStatus
  //         ? tenders.filter(tender => tender.tender_status === tenderStatus)
  //         : tenders;

  //       setTenderData(filteredTenders); // Set filtered data
  //       setFilteredData(filteredTenders); // Set filtered data
  //       setTotalItems(response.data.total); // Total count of items
  //     } catch (error) {
  //       console.error('Error fetching tenders:', error);
  //     }
  //   };

  //   fetchTenders();
  // }, [
  //   keyword,
  //   tenderType,
  //   sourceType,
  //   tenderSection,
  //   tenderStatus,
  //   district,
  //   upazila,
  //   publishFromDate,
  //   publishToDate,
  //   submissionFromDate,
  //   submissionToDate,
  //   currentPage,
  //   pageSize,
  //   tenderStatus,
  // ]);

  useEffect(() => {
    const fetchTenders = async () => {
      const queryParams = new URLSearchParams({
        key: keyword,
        // Include other parameters as needed
        // tender_type: tenderType,
        // source_type: sourceType,
        // tender_section: tenderSection,
        // tender_status: tenderStatus,
        // district_name: district,
        // upazila_name: upazila,
        // publish_from_date: publishFromDate ? dayjs(publishFromDate).format('YYYY-MM-DD') : '',
        // publish_to_date: publishToDate ? dayjs(publishToDate).format('YYYY-MM-DD') : '',
        // submission_from_date: submissionFromDate ? dayjs(submissionFromDate).format('YYYY-MM-DD') : '',
        // submission_to_date: submissionToDate ? dayjs(submissionToDate).format('YYYY-MM-DD') : '',
        skip: currentPage,
        limit: pageSize,
      });

      try {
        let url = `/user/tender-user/published-tender?key=${keyword}  `;
        if (userType === 'affiliator') {
          url = `/affiliator/tender-request/published-tender?key=${keyword}  `;
        }
        const response = await apiClient.get(url);
        const tenders = response.data.data;
        console.log('publish tender:', tenders);

        // Apply frontend filtering based on the status (if applicable)
        const filteredTenders = tenderStatus
          ? tenders.filter(tender => tender.tender_status === tenderStatus)
          : tenders;

        setTenderData(filteredTenders); // Set filtered data
        setFilteredData(filteredTenders); // Set filtered data
        setTotalItems(response.data.total); // Total count of items
      } catch (error) {
        console.error('Error fetching tenders:', error);
      }
    };

    fetchTenders();
  }, [
    keyword,
    // tenderType,
    // sourceType,
    // tenderSection,
    // tenderStatus,
    // district,
    // upazila,
    // publishFromDate,
    // publishToDate,
    // submissionFromDate,
    // submissionToDate,
    // currentPage,
    // pageSize,
    // userType,
  ]);

  // Handle pagination change
  const handlePageChange = page => {
    setCurrentPage(page);
  };

  // Toggle wishlist functions
  const addToFavorites = async tenderId => {
    const tenderID = tenderId.id;
    setLoading(true);
    try {
      const response = await apiClient.post('/user/tender-end-user/favourite', {
        ten_id: tenderID,
      });
      setWishlist(prev => [...prev, tenderID]);

      const successMessage =
        response?.data?.message || 'An unknown error occurred';
      Swal.fire({
        title: 'Success!',
        text: successMessage,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
        },
      });
    } catch (error) {
      console.error('Error adding to favorites:', error);
      const errorMessage =
        error.response?.data?.message || 'An unknown error occurred';
      Swal.fire({
        title: 'Failed!',
        text: errorMessage,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const removeFromFavorites = async tenderId => {
    const tenderID = tenderId.id;
    setLoading(true);
    try {
      const response = await apiClient.delete(
        `/user/tender-user/favourite/${tenderID}`
      );
      setWishlist(prev => prev.filter(id => id !== tenderID));
      const successMessage =
        response?.data?.message || 'An unknown error occurred';
      Swal.fire({
        title: 'Success!',
        text: successMessage,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
        },
      });
    } catch (error) {
      console.error('Error removing from favorites:', error);
      const errorMessage =
        error.response?.data?.message || 'An unknown error occurred';

      Swal.fire({
        title: 'Failed!',
        text: errorMessage,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-blue-600 text-white px-4 py-1 text-sm rounded-md',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const toggleWishlist = tender => {
    if (loading) return; // Prevent duplicate requests
    if (wishlist.includes(tender.id)) {
      removeFromFavorites(tender);
    } else {
      addToFavorites(tender);
    }
  };

  // const handleViewDetailsClick = tenderId => {
  //   if (userType === 'affiliate') {
  //     navigate(`/affiliator/tender-request/published-tender/${tenderId}`);
  //   } else {
  //     navigate(`/user/tender-user/published-tender/${tenderId}`);
  //   }

  // };

  const handleViewDetailsClick = tenderId => {
    navigate(`/view-my-tender-details/${tenderId}`);
  };

  return (
    <div className="p-6 mt-24 md:mt-36  max-w-7xl container mx-auto">
      <h2 className="text-2xl font-bold mb-3 md:mb-6">Tender Search</h2>

      {/* Filter Controls */}
      <div className="bg-gray-100 p-4 rounded grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {/* First Row */}
        <div>
          <label className="block text-gray-700 font-medium mb-1">
            Search Your Tender
          </label>
          <input
            type="text"
            placeholder="Search by keyword"
            value={keyword}
            onChange={e => setKeyword(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
        </div>

        {/* <div>
          <label className="block text-gray-700 font-medium mb-1">
            Publish Date
          </label>
          <div className="flex gap-2">
            <DatePicker
              selected={publishFromDate}
              onChange={date => setPublishFromDate(date)}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholderText="From"
            />
            <DatePicker
              selected={publishToDate}
              onChange={date => setPublishToDate(date)}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholderText="To"
            />
          </div>
        </div>
        
        <div>
          <label className="block text-gray-700 font-medium mb-1">
            Submission Date
          </label>
          <div className="flex gap-2">
            <DatePicker
              selected={submissionFromDate}
              onChange={date => setSubmissionFromDate(date)}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholderText="From"
            />
            <DatePicker
              selected={submissionToDate}
              onChange={date => setSubmissionToDate(date)}
              className="w-full p-2 border border-gray-300 rounded-lg"
              placeholderText="To"
            />
          </div>
        </div> */}

        {/* Second Row */}
        {/* <div>
          <label className="block text-gray-700 font-medium mb-1">
            Tender Type
          </label>
          <select
            value={tenderType}
            onChange={e => setTenderType(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-lg"
          >
            <option value="">All</option>
            <option value="free">Free</option>
            <option value="hot">Hot</option>
            <option value="popular">Popular</option>
            <option value="corrigendum">Corrigendum</option>
            <option value="int_popular">International Popular</option>
          </select>
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">
            Source Type
          </label>
          <select
            value={sourceType}
            onChange={e => setSourceType(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-lg"
          >
            <option value="">All</option>
            <option value="e-GP">e-GP</option>
            <option value="Newspaper">Newspaper</option>
            <option value="Online">Online</option>
            <option value="Website">Website</option>
          </select>
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">
            Tender Section
          </label>
          <select
            value={tenderSection}
            onChange={e => setTenderSection(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-lg"
          >
            <option value="">All</option>
            <option value="private">Private</option>
            <option value="local">local</option>
            <option value="govt">Government</option>
            <option value="international">International</option>
          </select>
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">
            Tender Status
          </label>
          <select
            value={tenderStatus}
            onChange={e => setTenderStatus(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-lg"
          >
            <option value="">All</option>
            <option value="live">Live</option>
            <option value="expired">Expired</option>
          </select>
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">
            District
          </label>
          <input
            type="text"
            placeholder="Enter district"
            value={district}
            onChange={e => setDistrict(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
        </div>

        <div>
          <label className="block text-gray-700 font-medium mb-1">
            Upazila
          </label>
          <input
            type="text"
            placeholder="Enter upazila"
            value={upazila}
            onChange={e => setUpazila(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
        </div> */}
      </div>

      {/* Display Tenders in Card Layout */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2 gap-4 md:mt-14 mt-6 py-4">
        {filteredData.length > 0 ? (
          filteredData.map(tender => (
            <div
              key={tender.id}
              className="bg-white border w-full shadow-md rounded-lg md:p-4 p-2 relative flex flex-col"
            >
              <h3 className="md:text-lg text-sm font-semibold mb-2 md:w-11/12 w-full">
                {tender.name}
              </h3>
              <div className="flex gap-4 bg-BrowsBg md:p-2 p-0.5 rounded-md w-full">
                <div className="mt-2 lg:ml-4 ml-2 mb-2">
                  <img
                    src={
                      tender.company_logo
                        ? `${PHOTO_BASE_URL_Admin}${tender.company_logo}`
                        : 'TenderLogo' // Placeholder image if no logo is available
                    }
                    alt={`${tender.name} Logo`}
                    className="lg:w-36 w-14 h-12 lg:h-28 md:mx-auto lg:mx-auto"
                  />
                </div>
                <div>
                  <TenderDescriptionDate
                    data={{
                      submission_date: tender.submission_date,
                      expired_after: tender.expired_after,
                      publishOn: tender.publish_on,
                      publish_on_before: tender.publish_on_before,
                      tender_status: tender.tender_status,
                    }}
                  />
                </div>
              </div>
              <div className="py-1.5 md:mt-2 mt-2">
                <div>
                  <TenderDescriptionID
                    data={{
                      tenderID: tender.tender_id,
                      invitation_for: tender.invitation_for,
                      type: tender.type,
                    }}
                  />
                </div>
              </div>

              <div className="mt-auto flex justify-between items-center">
                {/* View Details Button */}
                <button
                  onClick={e => {
                    e.stopPropagation();
                    handleViewDetailsClick(tender.id);
                  }}
                  className="border border-gray-300 text-blue-400 py-1 px-4 rounded-md hover:bg-gray-100"
                >
                  View Details
                </button>

                {/* Wishlist Icon */}
                {/* <FaHeart
                  className={`cursor-pointer ${wishlist.includes(tender.id)
                    ? 'text-red-500 cursor-not-allowed pointer-events-none'
                    : 'text-black'
                    }`}
                  onClick={() => {
                    if (!wishlist.includes(tender.id)) {
                      toggleWishlist(tender);
                    }
                  }}
                /> */}
              </div>

              {/* Total Views */}
              <div className="absolute md:top-4 top-2 md:right-4 right-2 flex items-center text-gray-500 bg-red-100 px-4 py-1 rounded-md">
                <FaEye className="mr-1" />
                <span>{tender.total_view || 0}</span>
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-full text-center flex items-center justify-center w-full ">
            <img src={tenderNotFoundImage} alt="" className="object-contain " />
          </div>
        )}
      </div>

      {/* Pagination */}
      <div className="flex justify-center mt-4">
        <Pagination
          current={currentPage}
          total={totalItems}
          pageSize={pageSize}
          onChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default MyPublishTender;
